import Hammer from 'hammerjs'

export function debounce(func, wait, immediate) {
  var timeout
  return function() {
    var context = this
    var args = arguments
    var later = function() {
      timeout = null
      if (!immediate) func.apply(context, args)
    }
    var callNow = immediate && !timeout
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
    if (callNow) func.apply(context, args)
  }
}

export function throttle(callback, wait, context = this) {
  let timeout = null
  let callbackArgs = null

  const later = () => {
    callback.apply(context, callbackArgs)
    timeout = null
  }

  return function() {
    if (!timeout) {
      callbackArgs = arguments
      timeout = setTimeout(later, wait)
    }
  }
}

export function each(array, callback, scope) {
  for (let i = 0; i < array.length; i += 1) {
    callback.call(scope, i, array[i])
  }
}

export function $1(selector, context) {
  return (context || document).querySelector(selector)
}

export function $(selector, context) {
  return (context || document).querySelectorAll(selector)
}

export function whichTransitionEvent() {
  var t
  var el = document.createElement('fakeelement')
  var transitions = {
    'transition': 'transitionend',
    'OTransition': 'oTransitionEnd',
    'MozTransition': 'transitionend',
    'WebkitTransition': 'webkitTransitionEnd',
  }

  for(t in transitions) {
    if(el.style[t] !== undefined) {
      return transitions[t]
    }
  }
}

export function getClosest(elem, selector) {
  if (!Element.prototype.matches) {
    Element.prototype.matches =
      Element.prototype.matchesSelector ||
      Element.prototype.mozMatchesSelector ||
      Element.prototype.msMatchesSelector ||
      Element.prototype.oMatchesSelector ||
      Element.prototype.webkitMatchesSelector ||
      function(s) {
        var matches = (this.document || this.ownerDocument).querySelectorAll(s),
            i = matches.length;
        while (--i >= 0 && matches.item(i) !== this) {}
        return i > -1
      }
  }

  // Get the closest matching element
  for ( ; elem && elem !== document; elem = elem.parentNode ) {
    if ( elem.matches( selector ) ) return elem;
  }
  return null
}

export function insertAfter(newNode, referenceNode) {
  referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}

export function parseJson(string) {
  try {
    return JSON.parse(string)
  } catch (e) {
    return null
  }
}

export function getParams (url) {
	var params = {};
	var parser = document.createElement('a');
	parser.href = url;
	var query = parser.search.substring(1);
	var vars = query.split('&');
	for (var i = 0; i < vars.length; i++) {
		var pair = vars[i].split('=');
		params[pair[0]] = decodeURIComponent(pair[1]);
	}
	return params;
};

export function getAjax(url, success) {
  var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
  xhr.open('GET', url);
  xhr.onreadystatechange = function() {
      if (xhr.readyState>3 && xhr.status==200) { success(xhr.responseText); }
  };
  xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
  xhr.send();
  return xhr;
}

export function postAjax(url, data, success) {
  var params = typeof data == 'string' ? data : Object.keys(data).map((k) => {
    return encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) 
  }).join('&');

  var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP");
  xhr.open('POST', url);
  xhr.onreadystatechange = function() {
      if (xhr.readyState>3 && xhr.status==200) { 
        success(xhr.responseText);
      }
  };
  xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
  xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
  xhr.send(params);
  return xhr;
}

export function addXMLRequestCallback(callback){
  var oldSend, i;
  if (XMLHttpRequest.callbacks) {
    // we've already overridden send() so just add the callback
    XMLHttpRequest.callbacks.push(callback);
  } else {
    // create a callback queue
    XMLHttpRequest.callbacks = [callback];
    // store the native send()
    oldSend = XMLHttpRequest.prototype.send;
    // override the native send()
    XMLHttpRequest.prototype.send = function () {
      // process the callback queue
      // the xhr instance is passed into each callback but seems pretty useless
      // you can't tell what its destination is or call abort() without an error
      // so only really good for logging that a request has happened
      // I could be wrong, I hope so...
      // EDIT: I suppose you could override the onreadystatechange handler though
      for (i = 0; i < XMLHttpRequest.callbacks.length; i++) {
        XMLHttpRequest.callbacks[i](this);
      }
      // call the native send()
      oldSend.apply(this, arguments);
    }
  }
}

// fade animation

export function fadeIn (el, t, display, cb) {
  const startTime = Date.now()
  let opacity = 0
  const animate = function () {
    const currentTime = Date.now()
    opacity = (currentTime - startTime) / t
    if (opacity < 1) {
      el.style.opacity = opacity
      requestAnimationFrame(animate)
    } else {
      opacity = 1
      el.style.opacity = 1
      if (cb) {
        cb()
      }
    }
  }
  el.style.display = display || 'block'
  animate()
}

export function fadeOut (el, t, cb) {
  const startTime = Date.now()
  let opacity = 1
  const animate = function () {
    const currentTime = Date.now()
    const progress = (1 - (currentTime - startTime) / t) * 100
    opacity = progress / 100
    if (progress > 0) {
      el.style.opacity = opacity
      requestAnimationFrame(animate)
    } else {
      opacity = 0
      el.style.opacity = 0
      el.style.display = 'none'
      if (cb) {
        cb()
      }
    }
  }
  animate()
}

export function hammerIt(elm) {
  var hammertime = new Hammer(elm, {});
  hammertime.get('pinch').set({
      enable: true
  });
  var posX = 0,
      posY = 0,
      scale = 1,
      last_scale = 1,
      last_posX = 0,
      last_posY = 0,
      max_pos_x = 0,
      max_pos_y = 0,
      transform = "",
      el = elm;

  hammertime.on('doubletap pan pinch panend pinchend', function(ev) {
      if (ev.type == "doubletap") {
          transform =
              "translate3d(0, 0, 0) " +
              "scale3d(2, 2, 1) ";
          scale = 2;
          last_scale = 2;
          try {
              if (window.getComputedStyle(el, null).getPropertyValue('-webkit-transform').toString() != "matrix(1, 0, 0, 1, 0, 0)") {
                  transform =
                      "translate3d(0, 0, 0) " +
                      "scale3d(1, 1, 1) ";
                  scale = 1;
                  last_scale = 1;
              }
          } catch (err) {}
          el.style.webkitTransform = transform;
          transform = "";
      }

      //pan    
      if (ev.type == "pan") {
        posX = last_posX + ev.deltaX;
        posY = last_posY + ev.deltaY;
        max_pos_x = el.clientWidth;
        max_pos_y = el.clientHeight;
        if (posX > max_pos_x) {
            posX = max_pos_x;
        }
        if (posX < -max_pos_x) {
            posX = -max_pos_x;
        }
        if (posY > max_pos_y) {
            posY = max_pos_y;
        }
        if (posY < -max_pos_y) {
            posY = -max_pos_y;
        }
      }


      //pinch
      if (ev.type == "pinch") {
          scale = Math.max(.5, Math.min(last_scale * (ev.scale), 4));
      }
      if(ev.type == "pinchend"){last_scale = scale;}

      //panend
      if(ev.type == "panend"){
          last_posX = posX < max_pos_x ? posX : max_pos_x;
          last_posY = posY < max_pos_y ? posY : max_pos_y;
      }

      transform =
              "translate3d(" + posX + "px," + posY + "px, 0) " +
              "scale3d(" + scale + ", " + scale + ", 1)";
      el.style.webkitTransform = transform;
  });
}

/**
 * @function getSreenSizes
 */
export function getSreenSizes() {
  const w = window
  const d = document
  const e = d.documentElement
  const g = d.getElementsByTagName('body')[0]
  return {
    width: w.innerWidth||e.clientWidth||g.clientWidth,
    height: w.innerHeight||e.clientHeight||g.clientHeight
  }
}

/**
 * @funciton paginateArray
 * @param {*} array 
 * @param {*} page_size 
 * @param {*} page_number 
 */
export function paginateArray (array, page_size, page_number) {
  --page_number; // because pages logically start with 1, but technically with 0
  return array.slice(page_number * page_size, (page_number + 1) * page_size);
}


// WEBPACK FOOTER //
// app/javascript/scripts/util.js